var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(_vm.$t('common.lbl.error_code_404')))]),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$t('common.msg.not_found_page')))])]),_c('a',{staticClass:"logo logo-img-1x",attrs:{"href":"/"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }